import useAPI from './useAPI'

export default function useMasterClaims() {
  const { data, error, mutate } = useAPI('/claims', 'get')

  return {
    items: data?.Items.sort(
      (a, b) => new Date(b.date_of_claim) - new Date(a.date_of_claim)
    ),
    isLoading: !data && !error,
    error,
    mutate,
  }
}
